const Thought = [
  {
    thought: "The Future Depends On What You Do Today.",
    author: "Mahatma Gandhi",
  },
  {
    thought: "Believe you can and you're halfway there.",
    author: "Theodore Roosevelt",
  },
  {
    thought: "The only way to do great work is to love what you do.",
    author: "Steve Jobs",
  },
  {
    thought: "Strive not to be a success, but rather to be of value.",
    author: "Albert Einstein",
  },
  {
    thought:
      "Do not wait to strike till the iron is hot, but make it hot by striking.",
    author: "William Butler Yeats",
  },
  {
    thought: "The mind is everything. What you think you become.",
    author: "Buddha",
  },
  {
    thought: "Everything has beauty, but not everyone sees it.",
    author: "Confucius",
  },
  {
    thought: "The journey of a thousand miles begins with one step.",
    author: "Lao Tzu",
  },
  {
    thought:
      "Happiness is not something readymade. It comes from your own actions.",
    author: "Dalai Lama",
  },
  {
    thought: "What we think, we become.",
    author: "Buddha",
  },
  {
    thought:
      "The best time to plant a tree was 20 years ago. The second best time is now.",
    author: "Chinese Proverb",
  },
];

export default Thought[Math.floor(Math.random() * Thought.length)];
